/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type UserReportGrid_surveys = {| |};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserReportGrid_surveys",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "WidgetTypeRouter_surveys",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "ExportCommentsWidget_surveys",
      "args": null
    }
  ],
  "type": "SurveyConnection"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/scenes/Report/components/ReportWrapper/components/UserReportGrid/__generated__/UserReportGrid_surveys.graphql.js